// Item <-> form data conversion shared by every item editor (the per-card
// editor in FoodMenu and the top-level Item actions), so all of them send
// the same complete payload.

export const emptyItem = () => ({
  name: { ar: "", en: "" },
  description: { ar: "", en: "" },
  allergens: { ar: "", en: "" },
  calories: { ar: "", en: "" },
  pricing: [{ name: "base", price: "", discount: null }],
  additionGroups: [],
  isBox: false,
});

const localizedCopy = (value) => ({ ar: value?.ar || "", en: value?.en || "" });

export const itemToForm = (item) => ({
  name: localizedCopy(item.name),
  description: localizedCopy(item.description),
  allergens: localizedCopy(item.allergens),
  calories: localizedCopy(item.calories),
  pricing: (item.pricing || []).map(({ name, price, discount }) => ({ name, price, discount: discount ? { type: discount.type, value: discount.value } : null })),
  additionGroups: item.additionGroups || [],
  isBox: Boolean(item.isBox),
});

// Images are not part of the payload: they only change through the upload
// endpoint, so an item save can never clear or replace one by accident.
export const formToPayload = (data) => ({
  name: data.name,
  description: data.description,
  allergens: data.allergens,
  calories: data.calories,
  isBox: Boolean(data.isBox),
  pricing: (data.pricing || []).map(({ name, price, discount }) => ({ name, price, discount: discount ? { type: discount.type, value: Number(discount.value) } : null })),
  additionGroups: (data.additionGroups || []).map((group) => ({ ...(group._id ? { _id: group._id } : {}), addition: typeof group.addition === "object" ? group.addition._id : group.addition })),
});

// True when the form holds exactly what the item already has.
export const samePayload = (a, b) => JSON.stringify(formToPayload(a)) === JSON.stringify(formToPayload(b));
